import type { TicketStatus } from '@core/Areas/AccountActivity/types'
import type { BetLoopShareTicket } from '@core/Areas/BetLoop/types'
import { getTicketStatus } from '@core/Areas/AccountActivity/Components/Ticket/helpers'

export const getBetLoopTicketStatus = (ticket: BetLoopShareTicket): TicketStatus => {
  const ticketStatus: TicketStatus =
    getTicketStatus(ticket, ticket.status === 'Pending' ? 'pending' : null) || 'Pending'

  let forceStatusOverride: TicketStatus | null = null

  if (ticketStatus === 'Won' && isMoneyBackRefund(ticket)) {
    forceStatusOverride = 'NoPayout'
  }

  return forceStatusOverride || ticketStatus
}

// =============
// Local Helpers
// =============

const isMoneyBackRefund = (ticket: BetLoopShareTicket) => {
  if (
    !ticket.specialInformation ||
    !ticket.specialInformation.length ||
    !ticket.specialInformation.some(x => x.specialTypeCode === 'MB')
  ) {
    return false
  }

  return ticket.payValue > 0 && ticket.payValue == ticket.investment.total
}
